<sms-user *ngIf="!showAdmin && currentUser.soultionTiers[0][0].help_Center" (closeHelpCenterEvent)="closeHelpCenterBuilder()"></sms-user>
<sms-solution-admin *ngIf="showAdmin" (closeHelpCenterEvent)="closeHelpCenterBuilder()"></sms-solution-admin>
